import { useEffect } from "react"
import Footer from "../../components/footer/footer"
import Header from "../../components/header/header"
import { customScript } from "../../common/customscript"
import Hero from "../../components/hero/hero"
import Features from "../../components/features/features"
import AboutSection from "../../components/about_section/about"
import HowWork from "../../components/how_work/howwork"
import ServicesSection from "../../components/services_section/servicessection"
import WatchVideo from "../../components/watch_video/watch_video"
import Team from "../../components/team/team"
import Testimonial from "../../components/testimonial/testimonial"
import Partner from "../../components/partner/partner"
import NewsLetter from "../../components/newsletter/newsletter"
import SearchModel from "../../components/search_model/search"
import Blog from "../../components/blog/blog"

const Home = () => {
    useEffect(() => {
        customScript()
    }, [])

    return (
            <>
                <Header />
                <Hero />
                <ServicesSection search={false} />
                <AboutSection />
                <HowWork />
                <Team />
                <Features />
                <Partner />
                <WatchVideo />
                <Testimonial />
                <Blog/>
                <NewsLetter />
                <Footer />
                <SearchModel/>
        </>
    )
}

export default Home